const vueSanitizeConfig = {
  allowedTags: ['ol', 'ul', 'li', 'p', 'u', 'em', 'strong', 'span', 'a', 'br'],
  allowedAttributes: {
    a: ['href', 'class', 'target']
  }
}
export default vueSanitizeConfig
